import React, { createContext, useContext, useMemo } from "react";

const UserContext = createContext(null);

export const UserProvider = ({ currentUser, children }) => {
  const value = useMemo(() => {
    const isRespondologyUser = currentUser && currentUser.is_respo_user === true;

    const role = currentUser && currentUser.role;
    const type = currentUser && currentUser.type;

    const isAnalyst = !isRespondologyUser && role === "analyst";
    const isEditor = isRespondologyUser || role === "editor";
    const isOwner = isRespondologyUser || role === "owner";

    const isEditable = isRespondologyUser || isEditor || isOwner;

    const isEnterpriseUser = type === 'EnterpriseUser';

    return {
      currentUser,
      isRespondologyUser,
      isAnalyst,
      isEditor,
      isOwner,
      isEditable,
      isEnterpriseUser,
    };
  }, [currentUser]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useCurrentUser = () => {
  return useContext(UserContext);
};
